import * as platform from 'platform';
import jstz from 'jstz';
import sentry from "../utils/sentry";
import actions from './actions';

export function reportError (description) {
    return (dispatch, getState) => {
        const environment = {
	    version: process.env.VERSION,
	    browser: platform.description,
	    locale: (navigator.language || navigator.browserLanguage).split('-')[0],
	    timeZone: jstz.determine().name()
        };

        dispatch({type: actions.REPORT_ERROR_IN_PROGRESS});
        
        getState().api.reportError(environment, description)
            .then((response) => dispatch({type: actions.REPORT_ERROR_SUCCESS}))
            .catch((error) => sentry.logException(error));
    };
}



// WEBPACK FOOTER //
// ./app/actions/reportError.js